function pack(message) {
    throw new TypeError('Not yet implemented');
}
function unpack(message) {
    throw new TypeError('Not yet implemented');
}
exports.pack = pack;
exports.unpack = unpack;
//# sourceMappingURL=XmlRPC.js.map